import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=a9af7e7e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=a9af7e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9af7e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9af7e7e')) {
      api.createRecord('a9af7e7e', component.options)
    } else {
      api.reload('a9af7e7e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=a9af7e7e&scoped=true&", function () {
      api.rerender('a9af7e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rYR2oHuJ35SY/JS/comp/CookieBox.vue"
export default component.exports